import { IMember } from "../../../framework/services/auth/models/Member.model"

export interface IUserModel {
  userId: string
  userName: string
  firstName: string,
  middleName: string,
  lastName: string,
  email: string
  contactId?: string,
  phoneNumber: string,
  invitationCode: string,

  entityId?: string,
  dashboardPageId?: string,
  loginPageId?: string,
  portals: string[],
  roles: string[]
  memberOf: IMember[],
  role?: UserRoleType
}


export enum UserRoleType {
  Father = "Father",
  Mother = "Mother",
  Guardian = "Guardian",
  EmergencyContact = 4,
  Visitor = 5,
  Child = 6,
  Sibling = 365970000,
}